import {
    createContext,
    FC,
    useState,
    useContext,
    PropsWithChildren,
    ReactNode,
    useMemo,
    useCallback,
  } from "react";
    import { TaoRuleFilters } from "@/types/tao-routing";

  const noop = () => null;

  const defaultValues =
  {
    filters: {
        departmentIds: [],
        departments: [],
        providerIds: [],
        providers: [],
        orderTypeIds: [],
        orderTypes: [],
        orderGenusList: [],
        bucketName: "",
        pageNumber: 0,
        pageSize: 1000,
    },
    updateFilters: noop,
    };

    export interface TaoRules {
        filters: TaoRuleFilters;
        updateFilters: (partial: Partial<TaoRuleFilters>) => void;
    }

    const TaoRulesContext = createContext<TaoRules>(defaultValues);

    export const TaoRulesContextProvider: FC<PropsWithChildren<ReactNode>> = ({ children }) => {
        const [filters, setFilters] = useState<TaoRuleFilters>(defaultValues.filters);

      const updateFilters = useCallback(
        (changes: Partial<TaoRuleFilters>, values?: string[]) => {
          values ?
            setFilters({ ...filters, [String(changes)]: values }) :
            setFilters({ ...filters, ...changes });

          }, [filters]);

        const values = useMemo(
            () => ({
              filters,
              updateFilters,
            }),
            [
              filters,
              updateFilters,
            ],
          );

        return (<TaoRulesContext.Provider value={values}>{children}</TaoRulesContext.Provider>);
    };

    export const useTaoRulesContext = () => useContext(TaoRulesContext);
